import './priceNotice.scss';

import React from 'react';

import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';
import {  IProduct } from '@sbi-international/boutik.gatsby.plugin.services';

export default function PriceNotice({
    product,
}: {
    product : IProduct  | undefined;
}) {
    const { t } = useTranslation('templatePages');
    const { currentLocale } = usePageLocalization();

    const hideNotice = (product: IProduct | undefined): boolean => {
        if (product === undefined) {
            return true;
        }

        const isCanadaWebSite = currentLocale.includes('_CA');
        const isUsaWebSite = currentLocale.includes('_US');

        const isOnlyMadeInCanada =
            product?.isMadeInCanada && !product?.isMadeInUSA;
        const isOnlyMadeInUSA =
            !product?.isMadeInCanada && product?.isMadeInUSA;

        if (isCanadaWebSite && isOnlyMadeInUSA) {
            return false;
        }

        if (isUsaWebSite && isOnlyMadeInCanada) {
            return false;
        }

        return true;
    };

    return (
        <div className={`price-notice ${hideNotice(product) && 'hide'}`}>
            <div className='price-notice-1'>{t('customs-duty-1')}</div>
            <div className='price-notice-2'>{t('customs-duty-2')}</div>
        </div>
    );
}